import {
  Dialog, DialogActions, DialogContent, DialogTitle,
} from '@mui/material';
import { FC, useState } from 'react';

import CustomButton from 'components/CustomButton';
import CustomDatePicker from 'components/CustomDatePicker';
import CustomDropdown from 'components/CustomDropdown';
import CustomInput from 'components/CustomInput';
import CustomTimePicker from 'components/CustomTimePicker';

import { getLocalUsStates } from 'utils/storageUtils';

import { DeliveryModalRowWrapper } from './index.styled';

interface DeliveryModalProps {
  open: boolean;
  onClose: () => void;
}

interface DeliveryDetailsForm {
  street: string;
  apt: string;
  city: string;
  state: string;
  zip: string;
  deliveryDate: Date | null;
  deliveryTime: Date | null;
  notes: string;
}

const DeliveryModal: FC<DeliveryModalProps> = ({
  open,
  onClose,
}) => {
  const states = getLocalUsStates();
  const [deliveryDetails, setDeliveryDetails] = useState<DeliveryDetailsForm>({
    street: '',
    apt: '',
    city: '',
    state: '',
    zip: '',
    deliveryDate: null,
    deliveryTime: null,
    notes: '',
  });

  const handleDeliveryDetailsChange = (key: string, value: string | Date | null) => {
    setDeliveryDetails({
      ...deliveryDetails,
      [key]: value,
    });
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="delivery-modal-title"
      aria-describedby="delivery-modal-description"
    >
      <DialogTitle>Delivery Details</DialogTitle>

      <DialogContent>
        <DeliveryModalRowWrapper>
          <CustomInput
            label="Street"
            size="small"
            fullWidth
            placeholder="Enter street"
            value={deliveryDetails.street}
            onChange={(e) => handleDeliveryDetailsChange('street', e.target.value)}
          />

          <CustomInput
            label="Apt/Unit"
            size="small"
            fullWidth
            placeholder="Enter apt/unit"
            value={deliveryDetails.apt}
            onChange={(e) => handleDeliveryDetailsChange('apt', e.target.value)}
          />

          <CustomInput
            label="City"
            size="small"
            fullWidth
            placeholder="Enter city"
            value={deliveryDetails.city}
            onChange={(e) => handleDeliveryDetailsChange('city', e.target.value)}
          />

          <CustomDropdown
            label="State"
            size="small"
            fullWidth
            options={states || []}
            onChange={(e) => handleDeliveryDetailsChange('state', e.target.value as unknown as string)}
          />

          <CustomInput
            label="Zip"
            placeholder="Enter zip"
            size="small"
            fullWidth
            value={deliveryDetails.zip}
            onChange={(e) => handleDeliveryDetailsChange('zip', e.target.value)}
          />

          <CustomDatePicker
            label="Delivery Date"
            onChange={(date) => handleDeliveryDetailsChange('deliveryDate', date)}
            value={deliveryDetails.deliveryDate}
            name="DeliveryDateModal"
            size="small"
            fullWidth
          />

          <CustomTimePicker
            label="Delivery Time"
            onChange={(date) => handleDeliveryDetailsChange('deliveryTime', date)}
            value={deliveryDetails.deliveryTime}
            name="deliveryTimeModal"
            size="small"
            fullWidth
          />

          <CustomInput
            label="Notes"
            size="small"
            multiline
            rows={5}
            fullWidth
            placeholder="Enter notes"
            value={deliveryDetails.notes}
            onChange={(e) => handleDeliveryDetailsChange('notes', e.target.value)}
          />
        </DeliveryModalRowWrapper>
      </DialogContent>

      <DialogActions>
        <CustomButton
          id="button-cancelDelivery"
          variant="outlined"
          onClick={onClose}
        >
          Cancel
        </CustomButton>

        <CustomButton
          id="button-saveDelivery"
          variant="contained"
          onClick={() => {}} // @TODO to be implemented
        >
          Save
        </CustomButton>
      </DialogActions>
    </Dialog>
  );
};

export default DeliveryModal;
